// Mock data for the Mechanical Engineering Portfolio
// Replace placeholder values with real info before deployment
import profilePhoto from "../assets/img/profile.jpeg";
import imgBlueOrigin from "../assets/img/BlueOrigin.jpeg";
import imgKTU from "../assets/img/KTU.webp";
import imgPivotal from "../assets/img/Pivotal.png";
import imgVeravanti from "../assets/img/Veravanti.png";
import imgWSU from "../assets/img/WSU.png";
import imgUCB from "../assets/img/UCB.jpeg";
import imgCrate from "../assets/img/crate.png";
import imgIvars from "../assets/img/ivars.jpeg";
import imgSEL from "../assets/img/Sel.jpeg";
import imgLolli from "../assets/img/lollicup.jpeg";
import imgTriangle from "../assets/img/triangle.png";

import AIcar_slide1 from "../assets/proj/485_final/Slide1.jpeg";
import AIcar_slide2 from "../assets/proj/485_final/Slide2.jpeg";
import AIcar_slide3 from "../assets/proj/485_final/Slide3.jpeg";
import AIcar_slide4 from "../assets/proj/485_final/Slide4.jpeg";

import imgMidterm from "../assets/proj/485_midterm/viz_04_nav2_waypoints.png";

import imgMotionTracker from "../assets/proj/motion_tracker/motionTracker.png";

import imgCougNotCoung from "../assets/proj/cougar_notcougar/HW7Q3_report1.png";

import imgMech from "../assets/proj/mechatronics_final/mechFinal.png";

import img10R80 from "../assets/proj/10R80/10r80.jpg";

import imgSpade from "../assets/proj/sel_spade_tool/selSpade.png";

import imgWack from "../assets/proj/wackcomm/wack.png";

import imgBMW from "../assets/proj/bmw/IMG_4949.jpeg";

import imgBlue from "../assets/proj/BlueOrigin/IMG_8939.jpeg";
import imgBlueExtra from "../assets/proj/BlueOrigin/Blue.jpg";

// 401 Mechatronics Final Robot
import img401Final from "../assets/proj/401_final/401Final.jpeg";
import img401Robot2 from "../assets/proj/401_final/IMG_3951.jpeg";

// Additional gallery imports for existing projects
import imgMidtermTrash from "../assets/proj/485_midterm/trashcan_detection.png";
import imgMotionPos1 from "../assets/proj/motion_tracker/3321_Position.png";
import imgMotionPos2 from "../assets/proj/motion_tracker/33333_Position.png";
import imgMotionBode from "../assets/proj/motion_tracker/OIL1_Bode.png";
import imgCougReport from "../assets/proj/cougar_notcougar/HW7Q3_report.png";
import img10R80a from "../assets/proj/10R80/IMG_4360.jpeg";
import img10R80b from "../assets/proj/10R80/IMG_4361.jpeg";
import img10R80c from "../assets/proj/10R80/IMG_4362.jpeg";
import img10R80d from "../assets/proj/10R80/IMG_4363.jpeg";
import imgBMW2 from "../assets/proj/bmw/IMG_4810.JPG";
import imgBMW3 from "../assets/proj/bmw/IMG_4921.JPG";
import imgBMW4 from "../assets/proj/bmw/IMG_5045.jpeg";
import imgBMW5 from "../assets/proj/bmw/IMG_5205.jpeg";
import imgBMW6 from "../assets/proj/bmw/IMG_5255.jpeg";

// F150 Rear Differential
import imgF150Diff1 from "../assets/proj/f150_diff/IMG_3431.jpeg";
import imgF150Diff2 from "../assets/proj/f150_diff/IMG_3432.jpeg";
import imgF150Diff3 from "../assets/proj/f150_diff/IMG_3433.jpeg";
import imgF150Diff4 from "../assets/proj/f150_diff/IMG_3458.jpeg";

//Sec 1
export const profile = {
	name: "Julian Lacey",
	initials: "JL",
	role: "Mechanical Engineer",
	tagline: "Designing, building, and analyzing intuitive systems with precision and purpose.",
	location: "[Seattle, Wa]",
	email: "Julianmlacey@gmail.com",
	phone: "+1 (425) 219-9467",
	linkedin: "https://linkedin.com/in/julacey",
	github: "https://github.com/julianmlacey",
	resumeUrl: "#", // replace with actual PDF URL
	graduating: "Class of 2026",
	university: "Washington State University",
	universityLogo: imgWSU,
	degree: "B.S. Mechanical Engineering",
	gpa: "",
	available: "Looking for full-time roles · Available July 2026",
	photoUrl: profilePhoto,
};

export const heroStats = [
	{ value: "10+", label: "Languages" },
	{ value: "9+", label: "Years Building Projects" },
	{ value: "25+", label: "Projects Delivered" },
	{ value: "20+", label: "Years Suffering from the Knack" },
];

export const aboutText = [
	"I'm a senior mechanical engineering undergraduate with a love for turning sketches into working hardware. From CAD models that survive FEA at 2 AM to robotics builds that finally roll on the first try, I thrive at the intersection of design, analysis, and hands-on prototyping.",
	"Throughout school I've led student teams, interned at manufacturing and aerospace companies, and shipped projects that taught me how messy, joyful, and precise real engineering really is. I'm graduating ready to bring that energy to a team that builds things that matter.",
];

export const aboutHighlights = ["Strong foundation in solid mechanics, thermodynamics & dynamics", "Hands-on with machining, 3D printing, and rapid prototyping", "Experienced with FEA, CFD, and tolerance analysis workflows", "Comfortable shipping in cross-functional, fast-moving teams"];

export const TAG_COLORS = {
	teal: { badge: "bg-teal-400 text-[#04100f]", hero: "bg-teal-400/15 text-teal-300 border border-teal-400/40" },
	yellow: { badge: "bg-yellow-400/90 text-[#1a1200]", hero: "bg-yellow-400/15 text-yellow-300 border border-yellow-400/40" },
	blue: { badge: "bg-blue-400/90 text-[#001433]", hero: "bg-blue-400/15 text-blue-300 border border-blue-400/40" },
	purple: { badge: "bg-purple-400/90 text-[#1a0033]", hero: "bg-purple-400/15 text-purple-300 border border-purple-400/40" },
	orange: { badge: "bg-orange-400/90 text-[#1a0800]", hero: "bg-orange-400/15 text-orange-300 border border-orange-400/40" },
	green: { badge: "bg-emerald-400/90 text-[#001a0d]", hero: "bg-emerald-400/15 text-emerald-300 border border-emerald-400/40" },
	red: { badge: "bg-red-400/90 text-[#200000]", hero: "bg-red-400/15 text-red-300 border border-red-400/40" },
};

export const PROJECT_TAGS = {
	featured: { label: "Featured", colorId: "teal", icon: "Star" },
	inProgress: { label: "In Progress", colorId: "yellow", icon: "Clock" },
	mechanicalDesign: { label: "Mechanical Design", colorId: "blue" },
	cad: { label: "CAD", colorId: "blue" },
	python: { label: "Python", colorId: "orange" },
	cpp: { label: "C/C++", colorId: "orange" },
	javascript: { label: "JavaScript", colorId: "orange" },
	machineLearning: { label: "Machine Learning", colorId: "purple" },
	robotics: { label: "Robotics", colorId: "green" },
	pytorch: { label: "PyTorch", colorId: "red" },
	slam: { label: "SLAM", colorId: "red" },
	gazebo: { label: "Gazebo", colorId: "red" },
};

export const projects = [
	{
		id: "p1",
		slug: "acc-racing-agent",
		title: "ACC Intelligent Racing Agent",
		category: "Reinforcement Learning",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "3 weeks" },
			{ label: "Team", value: "6 engineers" },
			{ label: "Role", value: "BC + PPO Training Lead" },
			{ label: "Category", value: "Deep RL / Vehicle Dynamics" },
		],
		summary: "End-to-end deep reinforcement-learning driving agent for Assetto Corsa Competizione. Two-phase pipeline: behavioral-cloning pre-training on human demonstrations, followed by PPO fine-tuning in closed-loop with the simulator.",
		tags: ["Python", "PyTorch", "PPO", "Behavioral Cloning", "CNN", "GRU", "Assetto Corsa", "RL"],
		image: [AIcar_slide1, AIcar_slide2, AIcar_slide3, AIcar_slide4],
		labels: ["featured", "inProgress"],
		metrics: [
			{ label: "Training Phases", value: "BC → PPO" },
			{ label: "Parameters", value: "4,008,950" },
			{ label: "Lap-time vs. baseline", value: "−10%" },
			{ label: "Architecture", value: "CNN + MLP + GRU" },
		],
		problem: "Build a deep RL agent that drives Assetto Corsa Competizione end-to-end from raw screen pixels and shared-memory telemetry — beating a human baseline with three consecutive clean laps while keeping the PPO loop convergent rather than divergent.",
		approach: [
			"Captured a 20 Hz dataset of 80×250 grayscale screen frames (mss + OpenCV) time-aligned with shared-memory telemetry (pyaccsharedmemory) and human action vectors, serialized to HDF5.",
			"Designed a multi-modal network: CNN image encoder over downsampled grayscale frames, MLP telemetry encoder with a learned discrete-gear embedding, single-layer GRU fusing vision + telemetry into a temporally consistent state.",
			"Phase 2 — Behavioral cloning on the human demonstration set to seed the policy with sane initial driving behavior.",
			"Phase 3 — Proximal Policy Optimization fine-tuning in closed-loop with the simulator over a virtual gamepad, with reward shaping on lap time and clean-lap consistency.",
			"Workstation: Intel i7-13700K, 64 GB DDR5, RTX 3080 + TITAN RTX dual-GPU rig for parallel rollout + training.",
		],
		results: [
			"Met all four acceptance criteria: ≥10% lap-time reduction vs. human baseline, three consecutive clean laps, convergent PPO training, faster-than-roommate lap time.",
			"3 simultaneous control outputs (steering, throttle, brake) produced by a recurrent policy at real-time rates.",
			"Wrote the full pipeline (~3,500 lines of PyTorch) covering model, data collection, training harness, and live control integration.",
		],
		galleries: [
			{ title: "Project Slides", items: [AIcar_slide1, AIcar_slide2, AIcar_slide3, AIcar_slide4] },
		],
		links: [],
	},
	{
		id: "p2",
		slug: "slam-exploration-turtlebot3",
		title: "SLAM + Entropy-Based RRT Exploration + A* Pathfinding",
		category: "Autonomous Exploration",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "5 months" },
			{ label: "Team", value: "Solo project" },
			{ label: "Role", value: "Full autonomy stack" },
			{ label: "Category", value: "Robotics & ROS2" },
		],
		summary: "ROS 2 autonomy stack for a Turtlebot3 in Gazebo: SLAM-driven occupancy mapping, entropy-weighted RRT frontier exploration, A*/Bresenham pathfinding, and RGB-D spherical-target detection.",
		tags: ["ROS2", "SLAM", "Gazebo", "Nav2", "A*", "RRT", "TF2", "Python", "OpenCV"],
		image: [imgMidterm, imgMidtermTrash],
		labels: ["featured"],
		metrics: [
			{ label: "Target Detection", value: "2 / 2 (100%)" },
			{ label: "Nav2 Waypoints", value: "21" },
			{ label: "Path-Length Compression", value: "93–95%" },
			{ label: "Occupancy Grid", value: "62,608 cells" },
		],
		problem: "Develop a Turtlebot3 autonomy stack that can build an occupancy map from LiDAR, autonomously explore unknown space using information gain, detect colored spherical targets via RGB-D, and return home — all in ROS 2 with no human intervention.",
		approach: [
			"Built the application on ROS 2 (Humble) with Nav2 for global/local planning + recovery and TF2 for map/odom/base_link/camera frame management.",
			"Wrote a custom exploration planner: RRT-style sampling in free space + entropy/information-gain scoring over frontier regions to bias toward high-uncertainty cells.",
			"Implemented A* on the live occupancy grid with Bresenham's line algorithm for efficient line-of-sight simplification of generated paths.",
			"Built the perception pipeline: RGB thresholding + Hough Circle Transform for candidate blobs, depth back-projection with camera intrinsics for 3D position, and RANSAC point-cloud pruning for outlier rejection.",
			"Coordinated explore → detect → return-to-home as a ROS 2 node with publishers/subscribers and an action-driven control flow.",
		],
		results: [
			"100% target detection (2/2 trash cans correctly localized in the map frame).",
			"93–95% path-length compression via line-of-sight simplification (305 cells → 19 waypoints on the long path).",
			"7 cooperating runtime modules integrated into a single autonomous stack; 7,728 lines of code.",
		],
		galleries: [
			{ title: "Mapping & Detection", items: [imgMidterm, imgMidtermTrash] },
		],
		links: [],
	},
	{
		id: "p3",
		slug: "me401-autonomous-robot",
		title: "ME 401 Autonomous Arena Robot",
		category: "Embedded Robotics",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "1 semester" },
			{ label: "Team", value: "Team of 4" },
			{ label: "Role", value: "Autonomy & Firmware" },
			{ label: "Category", value: "Mechatronics" },
		],
		summary: "Fully autonomous arena-competition robot built end-to-end on an ESP32 — perception, occupancy mapping, A* planning, PID trajectory tracking, and a hierarchical mission state machine in ~1,300 lines of embedded C++.",
		tags: ["C++", "ESP32", "A*", "PID", "FSM", "ISR", "Embedded"],
		image: [imgMech, img401Final, img401Robot2],
		labels: ["featured"],
		metrics: [
			{ label: "Occupancy Grid", value: "20 × 20 cells" },
			{ label: "Lines of C++", value: "~1,300" },
			{ label: "Mission States", value: "4 (IDLE → ATTACK → CAPTURE → PARK)" },
			{ label: "Sensors Fused", value: "Pose + Color + IR" },
		],
		problem: "Design and program a microcontroller-class autonomous robot that perceives the arena, plans around a moving opponent, and executes a mission-level strategy — all on a single ESP32 with real-time, interrupt-driven constraints.",
		approach: [
			"Built a 20 × 20 occupancy grid (120 mm/cell) reconstructed each planning cycle from known arena geometry plus a live opponent-pose injection — a real dynamic-obstacle planner.",
			"Implemented A* search with a Manhattan heuristic and 4-connected neighbors over the grid; bounded open/closed lists for microcontroller-safe memory.",
			"Wrote a closed-loop goToLocation() controller mixing distance + heading PIDs into differential-drive wheel commands; hardware-timer ISR runs the PID loop on a fixed cadence.",
			"Added quadrature-encoder odometry (10 µs tick resolution) fused with external pose tracking for drift-free localization.",
			"Mission logic: hierarchical finite-state machine driving objective selection, capture sequencing, and the end-game park-the-bus retreat — all with ISR-safe shared state.",
		],
		results: [
			"Full mission cycle (IDLE → ATTACKING → CAPTURING → PARK-THE-BUS) demonstrated in live competition runs against a live opponent.",
			"Color-based friend/foe discrimination and IR-median-filtered range gating both operational in the field.",
			"Dynamic replanning triggered by opponent motion produced reactive, not one-shot, autonomous behavior.",
		],
		galleries: [
			{ title: "Robot Build", items: [imgMech, img401Final, img401Robot2] },
		],
		links: [],
	},
	{
		id: "p4",
		slug: "oscillation-motion-tracker",
		title: "Oscillation Motion Tracker (Computer-Vision Sensor)",
		category: "Computer Vision",
		year: "2024",
		meta: [
			{ label: "Timeline", value: "1 semester" },
			{ label: "Team", value: "Team of 4" },
			{ label: "Role", value: "Vision Pipeline (Lead)" },
			{ label: "Category", value: "Signal Processing" },
		],
		summary: "OpenCV pipeline that converts smartphone video of a spring-mounted car into a fully identified second-order dynamic system — extracting natural frequency, cutoff frequency, and damping ratio across four track-surface treatments.",
		tags: ["Python", "OpenCV", "HoughCircles", "Bode Plot", "System ID", "Matplotlib"],
		image: [imgMotionTracker, imgMotionPos1, imgMotionPos2, imgMotionBode],
		labels: [],
		metrics: [
			{ label: "Surfaces Characterized", value: "4" },
			{ label: "Damping Ratio Spread", value: "0.076 → 0.544" },
			{ label: "Calibration", value: "2,170 px/m" },
			{ label: "Lines of Python", value: "~187" },
		],
		problem: "Use computer vision as the experimental sensor for a dynamics lab: turn raw smartphone video of a damped spring-mass-damper system into a clean displacement signal that can be fit to a second-order transfer function across four track-surface conditions.",
		approach: [
			"HSV color thresholding (H 0–30, S 200–255, V 200–255) to isolate an orange fiducial against arbitrary lab backgrounds.",
			"5 × 5 Gaussian blur followed by cv2.HoughCircles to localize the fiducial center sub-pixel accurately frame by frame.",
			"Pixel-to-meter calibration (2,170 px/m) and FPS read at runtime so the time axis scales correctly to any source camera.",
			"Detection overlay rendered to an HD AVC1 MP4 for visual QA, and displacement exported to CSV for system-ID work downstream.",
			"Team fit a second-order transfer function to each impulse response and produced Bode (magnitude + phase) plots per surface.",
		],
		results: [
			"Damping ratio spread of 7× (0.076 → 0.544) and natural frequency spread of 37% (12.24 → 16.81 rad/s) cleanly separated all four surfaces.",
			"Plexiglass control: ω_n = 14.96 rad/s, ζ = 0.138; Caramel: ω_n = 16.81 rad/s, ζ = 0.544; 80W90 oil: ω_n = 13.37 rad/s, ζ = 0.076; Molasses: ω_n = 12.24 rad/s, ζ = 0.324.",
			"Vision pipeline resolved surface-to-surface differences with enough fidelity to support the analytical conclusions.",
		],
		galleries: [
			{ title: "Displacement & Bode Plots", items: [imgMotionPos1, imgMotionPos2, imgMotionBode] },
		],
		links: [],
	},
	{
		id: "p5",
		slug: "cougar-cnn-classifier",
		title: "Cougar vs. NotACougar — CNN Image Classifier",
		category: "Neural Networks",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "1 month" },
			{ label: "Team", value: "Solo project" },
			{ label: "Role", value: "Designer & Trainer" },
			{ label: "Category", value: "Deep Learning" },
		],
		summary: "PyTorch CNN that classifies whether an image contains a cougar. Built on a custom labeled dataset with proper train/val/test split, per-class precision/recall, confusion matrix, and dropout + class-weighting regularization.",
		tags: ["Python", "PyTorch", "CNN", "Image Classification", "Confusion Matrix"],
		image: [imgCougNotCoung, imgCougReport],
		labels: [],
		metrics: [
			{ label: "Test Accuracy", value: "89.3%" },
			{ label: "NotACougar Recall", value: "90.6%" },
			{ label: "Cougar Recall", value: "86.3%" },
			{ label: "Training Epochs", value: "25" },
		],
		problem: "Train a binary cougar/not-cougar classifier on a custom image dataset, clearing the assignment's ~80% accuracy bar — with proper train/val/test splitting, per-class metrics, and no observable overfitting.",
		approach: [
			"Built the dataset and trained a CNN feature extractor + fully-connected classifier in PyTorch with augmentation, class weighting, and dropout regularization.",
			"Iterated architecture depth, filter counts, and regularization across a CIFAR-10 baseline (HW7Q1) and the binary task (HW7Q3) for comparison.",
			"Evaluated with overall accuracy plus confusion matrix and per-class precision/recall — not just top-line accuracy.",
			"Saved model checkpoints (cifar_net.pth, cifar_net_improved.pth) for reproducibility.",
		],
		results: [
			"89.3% overall test accuracy on 713 held-out images after 25 epochs (637/713 correct), beating the 80% bar by ~9 percentage points.",
			"Confusion matrix: TP=176, FN=28, FP=48, TN=461. NotACougar precision/recall: 94.3% / 90.6%. Cougar precision/recall: 78.6% / 86.3%.",
			"Validation curve climbed 81% → 89% over the run with train/val curves tracking together — no obvious overfitting.",
		],
		galleries: [
			{ title: "Evaluation Reports", items: [imgCougNotCoung, imgCougReport] },
		],
		links: [],
	},
	{
		id: "p6",
		slug: "cimpi-waam-acoustic",
		title: "CIMPI — Acoustic Quality Control for WAAM",
		category: "Undergraduate Research",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "Ongoing (2025–2026)" },
			{ label: "Team", value: "CIMPI Lab" },
			{ label: "Role", value: "Data Acquisition + Mount Design" },
			{ label: "Category", value: "ML for Manufacturing" },
		],
		summary: "Acoustic-based in-situ defect detection for Wire Arc Additive Manufacturing. CNN classifies humping, porosity, lack of fusion, undercut, and clean deposition from STFT spectrograms of weld-arc audio. Presented at WSU SURCA; submitted to MSEC 2026.",
		tags: ["Python", "STFT", "Spectrograms", "CNN", "Sensor Fusion", "WAAM", "DSP"],
		image: imgWSU,
		labels: ["featured"],
		metrics: [
			{ label: "Reported CNN Accuracy", value: "~97%" },
			{ label: "Best-Op F1", value: "0.560" },
			{ label: "STFT Configs Swept", value: "9" },
			{ label: "Training Epochs / config", value: "500" },
		],
		problem: "Wire Arc Additive Manufacturing has historically relied on ex-situ post-process inspection — wasteful and slow. We needed a real-time, low-cost in-situ defect detector that uses microphone audio of the weld arc co-registered with robot-arm position to localize defects on the printed bead.",
		approach: [
			"Designed and fabricated the microphone mounting hardware for the WAAM fixture to stabilize the sensor and minimize mechanical coupling from the robot.",
			"Authored the data-capture program that synchronizes audio sampling, robot motion commands, and on-disk persistence into a spatially-registered labeled dataset.",
			"Downstream pipeline (team): noise filtering, Short-Time Fourier Transform → spectrograms, CNN training to classify defect types across varying voltage, wire feed speed, working distance, and travel speed.",
			"Class-imbalance handling at the training stage via under-sampling, over-sampling, and weighted sampling strategies.",
		],
		results: [
			"Reported ~97% CNN classification accuracy on 0.2 s spectrogram windows with 90% overlap, 256 hop size, 70/30 split (paper headline).",
			"Swept 4 time-window lengths × 9 STFT configurations × 5 class-imbalance ratios × 3 mitigation strategies for robustness.",
			"Confusion matrix at best operating point: 3,182 TN, 1 FP, 7 TP, 10 FN — precision 0.875, recall 0.412, F1 0.560.",
			"Work accepted at WSU SURCA and submitted to MSEC 2026 (MSEC2026-183051).",
		],
		galleries: [],
		links: [],
	},
	{
		id: "p7",
		slug: "asteroids-cpp-game",
		title: "Asteroids — C++ / OpenGL Game Clone",
		category: "Game Development",
		year: "2024",
		meta: [
			{ label: "Timeline", value: "1 semester" },
			{ label: "Team", value: "Solo project" },
			{ label: "Role", value: "Engine + gameplay" },
			{ label: "Category", value: "Real-time Systems" },
		],
		summary: "Reimplemented Atari Asteroids from scratch in modern C++ with an OpenGL rendering pipeline, GLFW windowing, and Dear ImGui debug overlay. ~2,600 lines of modular C++ with a built-in test-case harness.",
		tags: ["C++", "OpenGL", "GLFW", "Dear ImGui", "Makefile", "OOP"],
		image: imgWSU,
		labels: [],
		metrics: [
			{ label: "Lines of C++", value: "~2,600" },
			{ label: "Source Modules", value: "5+" },
			{ label: "Build", value: "Makefile (cross-platform)" },
			{ label: "Renderer", value: "OpenGL + GLFW" },
		],
		problem: "Build the classic Atari Asteroids from scratch using modern C++ with disciplined module design, a real-time fixed-timestep loop, debuggable runtime state, and a build system that compiles on Mac and MSYS2.",
		approach: [
			"Modular C++ architecture separating game-object base classes, player logic, physics/module updates, and rendering.",
			"Real-time game loop with fixed-timestep updates, input polling via GLFW, and OpenGL draw calls.",
			"Dear ImGui overlay for in-game debugging, parameter tuning, and state visualization.",
			"Test-case harness for unit-level validation of physics and game-object behavior.",
			"Makefile-based cross-platform build with documented install instructions in README.",
		],
		results: [
			"Classic arcade title reproduced from scratch with a real-time C++ engine.",
			"Cross-platform build documented and reproducible from a clean checkout.",
			"Project demonstrates real-time loop design, OpenGL pipeline familiarity, and disciplined C++ code structure transferable to embedded perception / flight-software work.",
		],
		galleries: [],
		links: [{ label: "GitHub repo", url: "https://github.com/JulianmLacey/Asteroids" }],
	},
	{
		id: "p8",
		slug: "blue-origin-capstone",
		title: "Blue Origin Capstone — Flow Rack & Visual Management",
		category: "Manufacturing Engineering",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "Spring 2026" },
			{ label: "Team", value: "WSU × Blue Origin capstone" },
			{ label: "Role", value: "Design lead & stakeholder owner" },
			{ label: "Category", value: "Lean / Visual Management" },
		],
		summary: "Senior capstone delivering a flow-rack-based visual management system for valve-case logistics across Blue Origin facilities — eliminating launch-schedule risk from case shipment variability and reclaiming significant assembly-floor square footage.",
		tags: ["Lean", "5S", "Kanban", "Logistics", "Stakeholder Mgmt", "SOP Authoring"],
		image: [imgBlue, imgBlueExtra],
		labels: ["featured"],
		metrics: [
			{ label: "MVP Specs Met", value: "100%" },
			{ label: "Floor Footprint Reduction", value: "~94%" },
			{ label: "Capital Cost", value: "$0" },
			{ label: "Inventory Comprehension", value: "≤10 s" },
		],
		problem: "Valve cases required to support Blue Origin assembly-floor operations were arriving unpredictably and stockpiling in piles that consumed valuable floor space — introducing real risk of pushing rocket-launch schedules. We needed a single system that could de-risk the launch schedule, reclaim floor space, and still meet demand at every facility.",
		approach: [
			"Designed a flow-rack visual-management system with first-in / first-out case flow, at-a-glance Kanban inventory signaling, and demand-pull replenishment.",
			"Modeled a shipping-cadence schedule that minimized transportation cost while guaranteeing case availability at each demand point.",
			"Built the system around Lean / 5S principles (visual controls, standard locations, eliminate clutter) so any operator could see system status without a computer.",
			"Cross-functional engagement: iterated with assembly-floor technicians, logistics personnel, and senior management — folding bottom-up operator feedback and top-down management constraints into one design.",
			"Authored Standard Operating Procedures, Temporary Work Order additions, and training procedures that re-established case traceability across the full lifecycle.",
		],
		results: [
			"100% of MVP specifications met or exceeded — no items descoped or waived.",
			"~94% reduction in allocated assembly-floor square footage (300 ft² maximum → 18 ft² deployed).",
			"$0 capital cost — system uses existing on-site U-Line shelving plus consumables (tape, laminated cards, labels).",
			"Closed the cross-facility traceability loop (Kent → OLS → PG5) and eliminated launch-schedule delays attributable to case shipment variability.",
		],
		galleries: [
			{ title: "Capstone Photos", items: [imgBlue, imgBlueExtra] },
		],
		links: [],
	},
	{
		id: "p9",
		slug: "sel-spade-tool",
		title: "SEL Spade Terminal Hand Guide",
		category: "Product Design",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Spring 2025" },
			{ label: "Team", value: "WSU × SEL capstone" },
			{ label: "Role", value: "Design & Prototyping" },
			{ label: "Category", value: "Manufacturing Tooling" },
		],
		summary: "Industry-sponsored capstone delivering a production-ready spade-terminal installation tool for SEL's protective-relay assembly lines. Full PD lifecycle: voice-of-customer → House of Quality → MVP → CAD → prototyping → qualification → handoff.",
		tags: ["SolidWorks", "DFM", "House of Quality", "Voice of Customer", "3D Printing", "Ergonomics"],
		image: imgSpade,
		labels: ["featured"],
		metrics: [
			{ label: "Cycle Time Reduction", value: "~79%" },
			{ label: "MVP Spec Margin", value: "8.5× faster than target" },
			{ label: "Unit Cost", value: "$0.37" },
			{ label: "Product Weight", value: "11.6 g" },
		],
		problem: "Spade-terminal installation on SEL's recloser-control assembly was causing recurring ergonomic strain and damaged components for ~50% of operators (8 of 16). SEL needed a tool footprint under 3 × 8 in, sub-30-second install time, no added process steps, zero bent or broken switch terminals, and no changes to existing assembly workflow.",
		approach: [
			"Voice-of-customer interviews with SEL operators and line engineers, translated into a structured requirements matrix using a House of Quality–style methodology.",
			"Iterative CAD design and three alpha/beta prototype generations (dielectric grease applicator, connector pliers, ergonomic hand guide) tested against a factory-accurate cardboard mockup.",
			"Weighted decision-matrix evaluation across seven MVP criteria to down-select the hand-guide concept.",
			"Final design iterated on operator feedback — a 60° angled skeletonized grip to accommodate larger hands without increasing part weight.",
			"Production-intent print spec: Carbon Fiber ABS, 0.25 mm nozzle, 0.06 mm layer, 5 wall loops, 15% grid infill.",
		],
		results: [
			"~79% per-terminal cycle-time reduction: 17 s baseline → 3.5 s with the selected hand guide.",
			"Beat SEL's <30 s MVP-spec target by ~8.5×.",
			"Selected design topped the prototype comparison matrix in nearly every category (7 evaluated criteria).",
			"Authored final technical report and delivered a production-ready 3D-printable tool at ~$0.37 unit cost — printable in-house at SEL with no workflow changes.",
		],
		galleries: [
			{ title: "Final Tool", items: [imgSpade] },
		],
		links: [],
	},
	{
		id: "p10",
		slug: "pivotal-build",
		title: "Pivotal Build — Construction Site Monitoring Node",
		category: "Embedded Systems",
		year: "2024",
		meta: [
			{ label: "Timeline", value: "Summer–Fall 2024" },
			{ label: "Team", value: "Engineering team" },
			{ label: "Role", value: "Hardware + Software Engineer" },
			{ label: "Category", value: "Edge Compute / IoT" },
		],
		summary: "Field-deployed, mesh-networked construction site monitoring node — Raspberry Pi-class edge compute + LTE + camera + RFID + cloud-connected web app. Delivered on a weekly Agile / Scrum cadence with hardware and software shipped by the same engineer.",
		tags: ["Raspberry Pi", "LTE", "Mesh Networking", "Embedded Linux", "Computer Vision", "Agile"],
		image: imgPivotal,
		labels: [],
		metrics: [
			{ label: "Cadence", value: "Weekly sprints" },
			{ label: "Discipline", value: "HW + SW (same engineer)" },
			{ label: "Connectivity", value: "LTE (no Wi-Fi dependency)" },
			{ label: "Architecture", value: "Multi-node mesh" },
		],
		problem: "Construction sites needed a way to reduce on-site PM presence, increase sub-contractor accountability, and maintain an evidentiary record of site changes — all on sites that lack reliable Wi-Fi and that demand rugged hardware deployed in the field.",
		approach: [
			"Designed and built prototype edge-compute nodes (Raspberry Pi class) with LTE connectivity for sites with no Wi-Fi.",
			"Implemented on-device computer vision for motion detection, QR-code recognition, and worker identification — streaming alerts and status to the cloud over LTE.",
			"Stood up the multi-node mesh architecture for coverage across large sites.",
			"Bread-boarded prototypes, iterated enclosures, and did field bring-up aligned to weekly sprint deliverables.",
			"Operated on Scrum cadence with stand-ups, sprint planning, sprint reviews, and retrospectives — shipping both sides of the system in lockstep.",
		],
		results: [
			"Drove the system from breadboard to field-deployed prototype while staying under hardware budget and exceeding client specifications.",
			"Reduced on-site PM presence and provided a real evidentiary record of site activity — a selling point for the company.",
			"Demonstrated end-to-end hardware-software integration on a sprint cadence — the production-floor reality of product development.",
		],
		galleries: [],
		links: [],
	},
	{
		id: "p11",
		slug: "bmw-e92-335i",
		title: "BMW E92 335i — Personal Performance Build",
		category: "Vehicle Mechanic",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Multi-year ownership" },
			{ label: "Team", value: "Solo (personal)" },
			{ label: "Role", value: "Owner / Wrench" },
			{ label: "Category", value: "Hobbyist / Hands-On" },
		],
		summary: "Personal BMW E92 335i hardware build covering FAPO TD04 turbocharger installation, VRSF supporting hardware, custom tuning, and end-to-end disassembly/reassembly of a twin-turbo direct-injection platform.",
		tags: ["Turbocharging", "Tuning", "Diagnostics", "Hand Tools", "DIY Mechanic"],
		image: [imgBMW, imgBMW2, imgBMW3, imgBMW4, imgBMW5, imgBMW6],
		labels: [],
		metrics: [
			{ label: "Turbo Upgrade", value: "FAPO TD04" },
			{ label: "Support HW", value: "VRSF intercooler/charge pipes" },
			{ label: "Tune", value: "Custom ECU" },
			{ label: "Daily-driven validation", value: "Multi-year" },
		],
		problem: "Personal automotive project demonstrating sustained hands-on mechanical aptitude on a complex high-pressure platform: tooling, diagnostic discipline, and the kind of \"I can actually turn a wrench\" credibility that production-floor integration work rewards.",
		approach: [
			"FAPO TD04 turbocharger installation and associated support components.",
			"VRSF hardware upgrades (intercooler, charge pipes, downpipes, etc.).",
			"Custom ECU tuning coordinated with the modified hardware.",
			"Routine diagnosis, disassembly, reassembly, and road validation of a direct-injection twin-turbo platform.",
		],
		results: [
			"End-to-end disassembly and reassembly of the engine bay performed solo.",
			"Multi-year stewardship of the same chassis with ongoing daily-driven validation of every modification.",
			"Personal R&D bench for hands-on mechanical fluency.",
		],
		galleries: [
			{ title: "Build Photos", items: [imgBMW, imgBMW2, imgBMW3, imgBMW4, imgBMW5, imgBMW6] },
		],
		links: [],
	},
	{
		id: "p12",
		slug: "f150-10r80-rebuild",
		title: "Ford F-150 10R80 Transmission Rebuild",
		category: "Vehicle Mechanic",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "7 days" },
			{ label: "Team", value: "Solo (driveway)" },
			{ label: "Role", value: "Diagnosis → Rebuild → Reinstall" },
			{ label: "Category", value: "Heavy Mechanical" },
		],
		summary: "Rebuilt a 10R80 10-speed automatic transmission out of my Ford F-150 on my driveway. Ground-up disassembly, clutch-pack replacement, and reassembly without dealership labor.",
		tags: ["Transmission", "Heavy Wrenching", "Diagnostics", "Personal Project"],
		image: [img10R80, img10R80a, img10R80b, img10R80c, img10R80d],
		labels: [],
		metrics: [
			{ label: "Saved vs. dealer", value: "$5,000" },
			{ label: "Clutch Packs Replaced", value: "5" },
			{ label: "Time to Rebuild", value: "7 days" },
			{ label: "Tools Available", value: "Driveway-grade" },
		],
		problem: "Factory 10R80 was exhibiting harsh shifts and slipping; dealer quotes were in the $5k+ range. Decided to do the rebuild myself — diagnose, source parts, R&R the transmission, replace clutch packs, and reinstall — on a residential driveway.",
		approach: [
			"Diagnosis from shift behavior + scan data to confirm internal clutch-pack failure rather than valve-body or external causes.",
			"Independent disassembly and parts selection — sourcing OEM-grade clutch packs and seals.",
			"Ground-up disassembly / reassembly with documented torque procedures.",
			"Hands-on mechanical fabrication and torqueing without a lift, using stands and a transmission jack.",
		],
		results: [
			"Successful rebuild completed in 7 days; truck back on the road without dealership labor.",
			"~$5,000 saved vs. the dealer quote.",
			"Demonstrated heavy-mechanical aptitude on a complex modern automatic transmission.",
		],
		galleries: [
			{ title: "Build Photos", items: [img10R80, img10R80a, img10R80b, img10R80c, img10R80d] },
		],
		links: [],
	},
	{
		id: "p13",
		slug: "f150-rear-differential",
		title: "Ford F-150 — Rear Differential Service",
		category: "Vehicle Mechanic",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Weekend project" },
			{ label: "Team", value: "Solo (driveway)" },
			{ label: "Role", value: "Service & Inspection" },
			{ label: "Category", value: "Drivetrain" },
		],
		summary: "Rear differential service and inspection on the F-150 — drain, inspect ring & pinion, swap fluid + additive, and reseal.",
		tags: ["Drivetrain", "Differential", "Hand Tools", "Personal Project"],
		image: [imgF150Diff1, imgF150Diff2, imgF150Diff3, imgF150Diff4],
		labels: [],
		metrics: [
			{ label: "Status", value: "Completed" },
			{ label: "Scope", value: "Service + reseal" },
			{ label: "Cost vs. shop", value: "Significantly lower" },
			{ label: "Confidence Gained", value: "+1 drivetrain skill" },
		],
		problem: "Routine drivetrain service that most owners outsource. Did the work on my own driveway to keep cost low and build hands-on drivetrain familiarity.",
		approach: [
			"Drained and inspected the rear differential, checking ring & pinion contact pattern and pinion preload.",
			"Replaced fluid + friction-modifier additive to spec.",
			"Resealed the differential cover with a fresh gasket and proper torque sequence.",
		],
		results: [
			"Service completed end-to-end on the driveway.",
			"Cleaner shifts, quieter drivetrain under load, and a small notebook of torque values + part numbers for next time.",
			"Adds another point of hands-on drivetrain experience to the F-150 build set.",
		],
		galleries: [
			{ title: "Service Photos", items: [imgF150Diff1, imgF150Diff2, imgF150Diff3, imgF150Diff4] },
		],
		links: [],
	},
	{
		id: "p14",
		slug: "f150-lift-kit",
		title: "Ford F-150 — Suspension Lift Kit",
		category: "Vehicle Mechanic",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Weekend project" },
			{ label: "Team", value: "Solo (driveway)" },
			{ label: "Role", value: "Install + Alignment" },
			{ label: "Category", value: "Suspension" },
		],
		summary: "Suspension lift-kit installation on the F-150 — strut spacers, leveling, tire clearance work, and post-install alignment check.",
		tags: ["Suspension", "Hand Tools", "Personal Project"],
		image: img10R80,
		labels: [],
		metrics: [
			{ label: "Status", value: "Completed" },
			{ label: "Scope", value: "Lift + clearance + alignment" },
			{ label: "Driveway-grade", value: "✓" },
			{ label: "Documentation", value: "Photos pending" },
		],
		problem: "Factory ride height was limiting tire size and approach clearance for trail use. Installed a lift kit on the driveway to gain clearance without paying shop rates.",
		approach: [
			"Disassembled the front strut assemblies and added leveling spacers / lift hardware.",
			"Verified clearance to wheel wells, lines, and CV boots at full lock.",
			"Performed a post-install alignment check (toe + camber) and re-torqued fasteners after the first shakedown drive.",
		],
		results: [
			"Lift installed and verified safe under road and mild off-road use.",
			"Gained tire/clearance margin needed for upgraded tires.",
			"Build photos pending — write-up will be expanded once documented.",
		],
		galleries: [],
		links: [],
	},
	{
		id: "p15",
		slug: "wackcomm-hackathon",
		title: "Wackcomm — 2024 Crimson Code Hackathon Winner",
		category: "Hackathon",
		year: "2024",
		meta: [
			{ label: "Timeline", value: "24 hours" },
			{ label: "Team", value: "Solo (1)" },
			{ label: "Role", value: "Full-stack" },
			{ label: "Category", value: "Web App" },
		],
		summary: "Slack-style full-stack collaborative project / task management web app: signup, create/join projects, add and complete tasks, leave comments. Built solo in 24 hours and deployed live at wackcomm.co.",
		tags: ["Node.js", "Express", "MySQL", "Sequelize", "Handlebars", "jQuery", "bcrypt", "Heroku"],
		image: imgWack,
		labels: [],
		metrics: [
			{ label: "Team Members", value: "1" },
			{ label: "Hours", value: "24" },
			{ label: "Cups of Coffee", value: "9" },
			{ label: "CS Students That Out-Coded Me", value: "0" },
		],
		problem: "Crimson Code 2024: build something real, ship it, and deploy it inside 24 hours, against a field of CS students — solo, as a mechanical engineering major.",
		approach: [
			"Node.js / Express backend with session-based authentication (express-session, bcrypt password hashing, uuid-int project keys).",
			"MySQL persistence through the Sequelize ORM with seed scripts (Faker for realistic test data).",
			"Handlebars server-rendered views + jQuery client-side interactivity, BlazeUI layout, SweetAlert2 modals.",
			"Dev REST API exposing the same data layer for programmatic use.",
			"Deployed on Heroku via Procfile; live at wackcomm.co.",
		],
		results: [
			"Won the 2024 Crimson Code Hackathon as a solo mechanical-engineering entrant.",
			"4 user-story features delivered: signup, projects, tasks, comments.",
			"Live-deployed and shareable URL handed in at the buzzer.",
		],
		galleries: [],
		links: [{ label: "Live site", url: "https://wackcomm.co" }],
	},
	{
		id: "p16",
		slug: "deck-build",
		title: "Backyard Deck Build",
		category: "Carpentry",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Planning" },
			{ label: "Team", value: "Solo" },
			{ label: "Role", value: "Designer / Builder" },
			{ label: "Category", value: "Personal" },
		],
		summary: "Personal carpentry project — designing and building a backyard deck. Full write-up + photos coming as the build progresses.",
		tags: ["Carpentry", "Framing", "Personal Project"],
		image: imgWSU,
		labels: ["inProgress"],
		metrics: [
			{ label: "Status", value: "Planning / In Progress" },
			{ label: "Scope", value: "Full deck build" },
			{ label: "Photos", value: "Coming soon" },
			{ label: "Write-up", value: "Pending" },
		],
		problem: "Standalone backyard carpentry project — designed and built end-to-end. This card is a placeholder until the build is far enough along to document properly.",
		approach: [
			"Site survey and footing layout.",
			"Material take-off and lumber sourcing.",
			"Framing, decking, and railing fabrication.",
			"Finishing and weather-proofing.",
		],
		results: ["Project in progress — full write-up will replace this placeholder."],
		galleries: [],
		links: [],
	},
	{
		id: "p17",
		slug: "lathe-restoration",
		title: "Manual Lathe Project",
		category: "Manufacturing",
		year: "2025",
		meta: [
			{ label: "Timeline", value: "Planning" },
			{ label: "Team", value: "Solo" },
			{ label: "Role", value: "Operator / Builder" },
			{ label: "Category", value: "Personal Shop" },
		],
		summary: "Hands-on lathe work — small personal-shop project. Detailed write-up and photo set coming once the project is far enough along to document.",
		tags: ["Lathe", "Machining", "Personal Project"],
		image: imgWSU,
		labels: ["inProgress"],
		metrics: [
			{ label: "Status", value: "Planning / In Progress" },
			{ label: "Scope", value: "TBD" },
			{ label: "Photos", value: "Coming soon" },
			{ label: "Write-up", value: "Pending" },
		],
		problem: "Personal-shop lathe project intended to build hands-on machining fluency outside of the formal coursework lab. This card is a placeholder until the work is documented.",
		approach: [
			"Lathe setup and tooling selection.",
			"Stock prep, turning, and finishing passes.",
			"Inspection and post-process documentation.",
		],
		results: ["Project in progress — full write-up will replace this placeholder."],
		galleries: [],
		links: [],
	},
	{
		id: "p18",
		slug: "pool-shot-prediction",
		title: "Pool Shot Prediction",
		category: "Computer Vision",
		year: "2026",
		meta: [
			{ label: "Timeline", value: "Planning" },
			{ label: "Team", value: "Solo" },
			{ label: "Role", value: "Designer & Developer" },
			{ label: "Category", value: "Computer Vision + Physics" },
		],
		summary: "Computer-vision + physics-based pool-shot predictor — table and ball detection from a single camera, rigid-body collision simulation, and trajectory search over cue-strike parameters to find sinkable shots.",
		tags: ["Computer Vision", "OpenCV", "Physics Simulation", "Trajectory Search"],
		image: imgWSU,
		labels: ["inProgress"],
		metrics: [
			{ label: "Status", value: "Planning" },
			{ label: "Vision", value: "Table + ball detection" },
			{ label: "Physics", value: "Rigid-body collision sim" },
			{ label: "Planner", value: "Trajectory search" },
		],
		problem: "Build a system that watches a pool table from a single camera, identifies ball positions, simulates ball-ball and ball-cushion collisions, and searches over cue-strike parameters to identify shots that sink target balls.",
		approach: [
			"Camera calibration and table-frame detection from a top-down or side view.",
			"Ball detection + ID via color + Hough circle / blob detection.",
			"Rigid-body collision model with friction and cushion restitution.",
			"Trajectory search over cue strike angle + force to rank candidate shots.",
		],
		results: ["Project in planning — full write-up will replace this placeholder once the prototype is up."],
		galleries: [],
		links: [],
	},
];

export const skillGroups = [
	{
		title: "CAD & Design",
		items: [
			{ name: "SolidWorks", level: 95 },
			{ name: "Fusion 360", level: 90 },
			{ name: "CATIA", level: 70 },
			{ name: "GD&T / Tolerancing", level: 85 },
		],
	},
	{
		title: "Simulation & Analysis",
		items: [
			{ name: "ANSYS Mechanical", level: 85 },
			{ name: "ANSYS Fluent (CFD)", level: 75 },
			{ name: "MATLAB / Simulink", level: 80 },
			{ name: "Hand calcs & FBDs", level: 95 },
		],
	},
	{
		title: "Manufacturing",
		items: [
			{ name: "CNC Machining", level: 75 },
			{ name: "3D Printing (FDM/SLA/SLM)", level: 90 },
			{ name: "Sheet metal & welding", level: 70 },
			{ name: "Composites layup", level: 65 },
		],
	},
	{
		title: "Programming & Tools",
		items: [
			{ name: "Python", level: 85 },
			{ name: "C / C++ (Arduino)", level: 75 },
			{ name: "Git & Linux", level: 80 },
			{ name: "LaTeX / technical writing", level: 80 },
		],
	},
];

export const education = [
	{
		id: "ed1",
		institution: "Washington State University",
		degree: "B.S. Mechanical Engineering",
		period: "Class of 2026",
		location: "Pullman, WA",
		gpa: "",
		logo: imgWSU,
		bullets: ["Concentration in Autonomous Systems"],
	},
	{
		id: "ed2",
		institution: "University of California Berkeley",
		degree: "Full-Stack Web Development Bootcamp",
		period: "Summer 2024",
		location: "Remote",
		gpa: "",
		logo: imgUCB,
		bullets: [],
	},
];

export const experiences = [
	{
		id: "e1",
		slug: "blue-origin-capstone",
		showDetail: false,
		role: "Senior Capstone Design Project",
		company: "Blue Origin",
		period: "Spring 2026",
		location: "Pullman, WA",
		logo: imgBlueOrigin,
		meta: [
			{ label: "Period", value: "Spring 2026" },
			{ label: "Location", value: "Pullman, WA" },
			{ label: "Type", value: "Capstone Project" },
		],
		overview: "Senior capstone project sponsored by Blue Origin, focused on solving a real operational problem aboard the Wally Funk 1 launch campaign.",
		bullets: [
			"Designed and deployed a Kanban driven centralized storage rack for Wally Funk 1 that eliminated a recurring risk of rocket launch delays caused by upstream Pelican case shortages.",
			"Authored Standard Operating Procedures, Temporary Work Order additions, and training procedures that re-established case traceability throughout the entire case life cycle.",
			"Drove top-down stakeholder alignment, working with multiple teams from directors to technicians, ensuring solution compatibility.",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e2",
		slug: "wsu-cimpi-researcher",
		showDetail: false,
		role: "Undergraduate Researcher",
		company: "Computational Intelligence for Materials and Process Innovation Labratory",
		period: "Spring 2026",
		location: "Pullman, WA",
		logo: imgWSU,
		meta: [
			{ label: "Period", value: "Spring 2026" },
			{ label: "Location", value: "Pullman, WA" },
			{ label: "Type", value: "Undergraduate Research" },
		],
		overview: "Contributed to applied ML research for detecting additive manufacturing defects in real time using in-situ acoustic sensing.",
		bullets: [
			"Contributed to a research effort that trained a Convolutional Neural Network on in-situ acoustic data to detect manufacturing defects in Wire Arc Directed Energy Deposition, achieving up to ~98% accuracy on STFT spectrograms.",
			"Engineered the data-acquisition pipeline that fused heterogeneous signals - microphone audio, robot pose, and welder telemetry- into a labeled dataset enabling the spatial-temporal co-registration required for supervised ML training.",
			"Designed and fabricated the welding head and microphone mounting hardware for the LS6 Industrial Robotic Arm",
			"Instructed and supervised underclassmen contributing to the project. Organized scheduling and maintained shop upkeep.",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e3",
		slug: "veravanti-intern",
		showDetail: false,
		role: "Mechanical/Manufacturing Engineering Intern",
		company: "VerAvanti Nanofabrication",
		period: "Summer 2025",
		location: "Mill Creek, WA",
		logo: imgVeravanti,
		meta: [
			{ label: "Period", value: "Summer 2025" },
			{ label: "Location", value: "Mill Creek, WA" },
			{ label: "Type", value: "Engineering Internship" },
		],
		overview: "E1 mm single-fiber endoscope with micron-scale camera head; goal was to automate human-performed micro-welds using a lathe-style welding apparatus with a 100 W Ytterbium fiber laser on a D30 vertical head.",
		bullets: [
			"Designed and prototyped a lathe-style fiber welding machine that automated the previously manual welding of micron-scale components on a 1mm single-fiber endoscope, eliminating human-error defects, enabling repeatable micro-welds, and increasing stage output 10-fold.",
			"Integrated on-board computer vision and CNN classification to monitor weld quality; keyhole splatter, burn-through, misalignment, and off-spec spot diameters simultaneously, eliminating the need for an additional quality check.",
			"Maintained daily project updates and progress communication directly to executives ",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e4",
		slug: "sel-senior-design",
		showDetail: false,
		role: "Senior Design Project",
		company: "Schweitzer Engineering Labratories",
		period: "Spring 2025",
		location: "Pullman, WA",
		logo: imgSEL,
		meta: [
			{ label: "Period", value: "Spring 2025" },
			{ label: "Location", value: "Pullman, WA" },
			{ label: "Type", value: "Senior Design Project" },
		],
		overview: "",
		bullets: [
			"Partnered with Schweitzer Engineering Laboratories (SEL) on a sponsored capstone project to resolve a spade-terminal installation issue affecting 50% of assembly workers, reducing ergonomic strain, component damage, and risk of injuries such as carpal tunnel and tendinitis.",
			"Defined MVP requirements in collaboration with SEL's line engineer, including tool footprint under 3 x 8 in, sub-30-second install time, no added process steps, and zero bent or broken switch terminals.",
			"Designed, 3D-printed, and bench-tested three alpha/beta prototypes (dielectric grease applicator, connector pliers, ergonomic hand guide) against a factory-accurate cardboard mockup of the recloser control box to validate fit, force application, and assembly time.",
			"Led a weighted decision-matrix evaluation across seven MVP criteria to down-select the hand guide concept, which cut per-terminal install time from ~17 s to ~3.5 s while fully seating the connector without damaging the switch.",
			"Iterated the final hand guide design based on SEL operator feedback, adding a 60°-angled skeletonized grip to accommodate workers with larger hands and improve leverage without increasing part weight.",
			"Delivered a production-ready 3D-printable tool (Carbon Fiber ABS, 0.25 mm nozzle, 0.06 mm layer, 5 wall loops, 15% grid infill) at a unit cost of ~$0.37, printable in-house at SEL with no changes to existing assembly workflow.",
			"Authored the final technical report and presented findings to the SEL sponsor, covering problem definition, constraints, prototype testing, trade-off analysis, and manufacturing recommendations.,",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e5",
		slug: "triangle-founder",
		showDetail: false,
		role: "Founder",
		company: "Triangle Fraternity",
		period: "Spring 2022 - Present",
		location: "Pullman, WA",
		logo: imgTriangle,
		meta: [
			{ label: "Period", value: "Spring 2022 – Present" },
			{ label: "Location", value: "Pullman, WA" },
			{ label: "Type", value: "Leadership" },
		],
		overview: "",
		bullets: ["Established only STEM professional/social Fraternity at WSU.", "Grew chapter from 1-60 members in 2 years", "Organized and oversaw events, community engagement, campus safety, member academics.", "Led and controlled chapter funds, decision-making, internal/external relations, and national communication"],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e6",
		slug: "pivotal-intern",
		showDetail: false,
		role: "Mechanical/Software Engineering Intern",
		company: "Pivotal Build",
		period: "Summer-Fall 2024",
		location: "Greater Seattle Area",
		logo: imgPivotal,
		meta: [
			{ label: "Period", value: "Summer–Fall 2024" },
			{ label: "Location", value: "Greater Seattle Area" },
			{ label: "Type", value: "Engineering Internship" },
		],
		overview: "Field-deployed, mesh-networked construction site monitoring node — Raspberry Pi + LTE connectivity + camera + RFID + cloud-connected web app. Agile/Scrum delivery.",
		bullets: [
			"Developed a job site security system to reduce on-site PM presence, increase sub-contractor attentiveness, and keep an evidentiary record of site changes, ultimately providing homeowners' safety and liability assurance, driving sales for the company",
			"Implemented on-device computer vision for motion detection, QR-code recognition, and worker identification, integrating real-time image processing and multi-modal sensing into a single node, streaming site alerts and status to the cloud over LTESercurity system, reduced on-site presence, increased sub-contractor output, selling point",
			"Led rapid-iteration hardware prototyping for the system, ensuring MVP benchmarks were met, and physical design remained under budget while exceeding client specifications.",
			"Iterated the project through rapid hardware/software cycles in an agile/scrum cadence with weekly sprint reviews, shareholder updates, and continuous technician feedback reviews",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e7",
		slug: "pivotal-contractor",
		showDetail: false,
		role: "Flex Contractor",
		company: "Pivotal Build",
		period: "Summer 2024",
		location: "Greater Seattle Area",
		logo: imgPivotal,
		meta: [
			{ label: "Period", value: "Summer 2024" },
			{ label: "Location", value: "Greater Seattle Area" },
			{ label: "Type", value: "Contract" },
		],
		overview: "",
		bullets: [
			"Led small 1–4-man crews across multiple job sites to finalize residential remodels ensuring all work is completed timely and up to standard.",
			"Mostly worked independently on a wide range of projects and sizes from handyman services to carpentry (decks, fences, trim, cabinetry, etc.), kitchen remodels, drywall installation, demo, flooring, painting.",
			"Worked directly with project manager and homeowners to assess and devise plans when issues arise. Ensuring adequate solution meet homeowners’ vision and standards, while mitigating companies’ liability and financial risk.",
		],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e8",
		slug: "kitchen-tune-up",
		showDetail: false,
		role: "Seasonal Technician, Carpentry",
		company: "Kitchen Tune Up",
		period: "May - August 2022",
		location: "Greater Seattle Area",
		logo: imgKTU,
		meta: [
			{ label: "Period", value: "May – Aug 2022" },
			{ label: "Location", value: "Greater Seattle Area" },
			{ label: "Type", value: "Seasonal" },
		],
		overview: "",
		bullets: ["Worked hands on remodeling kitchens, working with homeowners and suppliers to problem solve solutions in a timely fashion. Prioritizing communication within the team to achieve high quality renovations, while consistently reducing project timelines by 30%."],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e9",
		slug: "ivars-cook",
		showDetail: false,
		role: "Line Cook",
		company: "Ivar's Seafood Bar",
		period: "June 2020 - August 2021, Summer 2023",
		location: "Kirkland, WA",
		logo: imgIvars,
		meta: [
			{ label: "Period", value: "Jun 2020 – Aug 2021, Summer 2023" },
			{ label: "Location", value: "Kirkland, WA" },
			{ label: "Type", value: "Seasonal" },
		],
		overview: "",
		bullets: ["Lowered customer wait times drastically and brought organization through leadership."],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e10",
		slug: "crate-barrel",
		showDetail: false,
		role: "Seasonal Merchandise Associate",
		company: "Crate & Barrel",
		period: "December 2019 - January 2020",
		location: "Bellevue, WA",
		logo: imgCrate,
		meta: [
			{ label: "Period", value: "Dec 2019 – Jan 2020" },
			{ label: "Location", value: "Bellevue, WA" },
			{ label: "Type", value: "Seasonal" },
		],
		overview: "",
		bullets: ["Provided necessary product organization and support for sales associates, created a fun and open workspace, and with communication, built efficiency."],
		results: [],
		galleries: [],
		links: [],
	},
	{
		id: "e11",
		slug: "lollicup-barista",
		showDetail: false,
		role: "Barista",
		company: "Lollicup Fresh",
		period: "August 2019 - June 2020",
		location: "Kirkland, WA",
		logo: imgLolli,
		meta: [
			{ label: "Period", value: "Aug 2019 – Jun 2020" },
			{ label: "Location", value: "Kirkland, WA" },
			{ label: "Type", value: "Part-time" },
		],
		overview: "",
		bullets: [],
		results: [],
		galleries: [],
		links: [],
	},
];

export const certifications = [
	{ name: "Fundamentals of Engineering - Mechanical", issuer: "NCEES", year: "2023", credentialId: "" },
	{ name: "UCB Full-Stack Web Development", issuer: "Parchment", year: "2023", credentialId: "" },
	{ name: "SolidWorks Associate (CSWA) - Mechanical Design", issuer: "Dassault Systèmes", year: "2023", credentialId: "C-UDK2RQECVS" },
	{ name: "SolidWorks Associate (CSWA) - Simulation", issuer: "Dassault Systèmes", year: "2023", credentialId: "C-8M572CR3DT" },
	{ name: "Microsoft Office Certification: Word Expert", issuer: "Credly", year: "2021", credentialId: "" },
	{ name: "Microsoft Office Certification: Powerpoint", issuer: "Credly", year: "2021", credentialId: "" },
	{ name: "Microsoft Office Certification: Office Specialist", issuer: "Credly", year: "2021", credentialId: "" },
	{ name: "Microsoft Office Certification: Excel", issuer: "Credly", year: "2021", credentialId: "" },
];

export const awards = [
	{ name: "WSU 2026 SURCA Undergraduate Research Showcase", year: "2026" },
	{ name: "2024 Crimson Code Hackathon Winner", year: "2024" },
	{ name: "1st Place — Spring CAD Final Design Competition", year: "2024" },
];

export const publications = [
	{
		title: "Characterization of Soft Pneumatic Grippers for Variable Geometry Produce",
		venue: "IEEE Workshop on Soft Robotics (co-author)",
		year: "2024",
	},
];

export const interests = ["Cycling & bike-packing", "Hardware tear-downs", "Coffee gear engineering", "Sketching mechanisms", "Mountain trail running"];

export const references = [
	{
		name: "Neal Karlinsky",
		title: "Head of Communications for Jeff Bezos",
		company: "Family Office",
		email: "Neal@zeframllc.com",
		phone: "(310)-292-1049",
	},
	{
		name: "Ryan Pitzer",
		title: "Manufacturing Process Industrial Engineer",
		company: "Blue Origin",
		email: "rpitzer@blueorigin.com",
		phone: "(509)-432-1002",
	},
	{
		name: "Kyan Kotschevar-Smead",
		title: "C++ Embedded Software Engineer",
		company: "Boeing",
		email: "kyankks1@gmail.com",
		phone: "(425)-892-0578",
	},
];

export const navLinks = [
	{ id: "about", label: "About" },
	{ id: "projects", label: "Projects" },
	{ id: "skills", label: "Skills" },
	{ id: "experience", label: "Experience" },
	{ id: "extras", label: "Extra Bits" },
	{ id: "contact", label: "Contact" },
];
